export const SET_CLIENTS="app/clientsList/SET_CLIENTS"
